import { ROUTES } from "./routePaths";
import { Navigate } from "react-router-dom";
import useAppStore from "../store/useAppStore";

const PublicRoutes = ({ children }) => {
  const userToken = useAppStore((state) => state.userToken);
  if (userToken) return <Navigate to={ROUTES.LAUNCH} replace />;
  return children;
};

export default PublicRoutes;
